import BaseComponent from '../BaseComponent';
import { ClassNames } from '../../utils/dom/css-classes';
import SelectorEngine from '../../utils/dom/selector-engine';

const NAME = 'ExitWithoutSavingButton';

export default class ExitWithoutSavingButton extends BaseComponent {
	static get NAME() {
		return NAME;
	}

	constructor(element, config) {
		super(element);
		if (this._element) {
			this.classPrefix = config.classPrefix;
			this.buttonLabel = config.exitWithoutSavingButtonLabel || 'Exit without saving';
			this.buttonClasses = config.exitWithoutSavingButtonClasses || '';
		}
	}

	markup() {
		return `
			<div class="u-flex u-align-center" style="flex-direction:row">
				<button
					type="button"
					class="${this.classPrefix}__form-exit-without-saving-button lta-btn lta-btn--default lta-btn--block u-mt-3 ${
						this.buttonClasses || 'lta-btn--line'
					}"
					aria-label="Exit without saving"
				>
					${this.buttonLabel}
				</button>
			</div>
		`;
	}

	show() {
		const exitWithoutSavingButton = SelectorEngine.findOne(
			`.${this.classPrefix}__form-exit-without-saving-button`,
			this._element
		);
		exitWithoutSavingButton?.classList?.remove(ClassNames.Hidden);
	}

	hide() {
		const exitWithoutSavingButton = SelectorEngine.findOne(
			`.${this.classPrefix}__form-exit-without-saving-button`,
			this._element
		);
		exitWithoutSavingButton?.classList?.add(ClassNames.Hidden);
	}
}
